import { render, staticRenderFns } from "./SupplierNew.vue?vue&type=template&id=642e0e6a&scoped=true&"
import script from "./SupplierNew.vue?vue&type=script&lang=js&"
export * from "./SupplierNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e0e6a",
  null
  
)

export default component.exports